import React from 'react';
import styled from 'styled-components';
import {
  Title,
  Wrapper,
  Card
} from '../../../ChangeStudiesOption/info/components';
import WhiteContainer from '@/presentation/modules/procedures/components/ContainerProcedure/WhiteContainer';
import { Icon } from '../../../../../../../components';
import PSEIcon from '../../../../../../../../assets/icons/pse/pse-icon.svg';
import WarningMessage from '@/presentation/reusables/WarningMessage';

const ProcedureInformationText = styled.div`
  ul {
    list-style: disc;
    margin: 24px 16px 16px 24px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
  }
`;

interface ProcedureInfoComponentProps {
  inRegister?: boolean;
}

const ProcedureInfoComponent = ({
  inRegister
}: ProcedureInfoComponentProps) => (
  <div
    style={{ display: 'flex', width: '100%', flexDirection: 'column', gap: 16 }}
    data-testid="cmp-procedureInfoComponent"
  >
    <WhiteContainer inRegister={inRegister}>
      <Wrapper>
        <Card>
          <ProcedureInformationText>
            <Title>Requisitos</Title>
            <p>
              Para validar y anular el pago del Programa de Salud Estudiantil
              (PSE), necesitas tener un seguro vigente:
            </p>
            <ul
              style={{
                marginTop: 12,
                marginRight: 16
              }}
            >
              <li>{'Seguro Integral de Salud (SIS)'}</li>
              <li>{'Essalud'}</li>
              <li>{'Entidades Prestadoras de Salud (EPS)'}</li>
              <li>{'Fuerzas Armadas'}</li>
              <li>{'Policía Nacional del Perú'}</li>
            </ul>
            <p style={{ marginBottom: 16 }}>
              <b>¡Ahorra tiempo y valida tu seguro automáticamente!</b> Descarga
              el PDF de SUSALUD, adjúntalo y listo.
            </p>
            <WarningMessage
              message="Si realizaste el pago anticipado, valida primero tu seguro y solicita el reembolso a través de SAE."
              styledProps={{
                iconSize: 20,
                fontSize: '14px',
                borderRadius: '8px',
                background: '#D5E5F0',
                padding: '16px',
                alignItems: 'start',
                gap: '8px'
              }}
            />
          </ProcedureInformationText>
        </Card>
      </Wrapper>
    </WhiteContainer>
    <WhiteContainer inRegister={inRegister}>
      <div
        data-testid="cmp-open-pse"
        aria-hidden="true"
        onClick={() =>
          window.open(
            'https://info.utp.edu.pe/articulo/KA-01758',
            '_blank',
            'noopener,noreferrer'
          )
        }
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: 8,
          border: 'solid 1px #5B36F2',
          padding: 12,
          justifyContent: 'space-between'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            borderColor: '#5B36F2',
            cursor: 'pointer'
          }}
        >
          <img width={40} height={40} src={PSEIcon} alt="other" />
          <p
            style={{
              fontSize: 14,
              marginLeft: 12,
              marginRight: 8
            }}
          >
            <b>Programa de Salud Estudiantil (PSE) </b> ofrece una variedad de
            beneficios como servicios médicos y más.
          </p>
        </div>
        <Icon name="arrow-right" size={24} color="#5B36F2" />
      </div>
    </WhiteContainer>

    <WhiteContainer inRegister={inRegister}>
      <Wrapper>
        <Card>
          <Title>Pasos a seguir:</Title>
          <div>
            <ol
              style={{
                listStyleType: 'lower-aplha',
                marginLeft: '16px',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '20px',
                color: '#161D1F'
              }}
            >
              <li>
                Valida tu seguro automáticamente, adjuntando tu PDF del registro
                de afiliados de{' '}
                <a
                  style={{
                    color: '#5B36F2',
                    textDecorationLine: 'underline'
                  }}
                  href="https://app1.susalud.gob.pe/registro/"
                  target="_blank"
                  rel="noreferrer"
                >
                  SUSALUD
                </a>
                . Revisa este{' '}
                <a
                  style={{
                    color: '#5B36F2',
                    textDecorationLine: 'underline'
                  }}
                  href="https://drive.google.com/file/d/1uYJUcLKFRUHSan1zwGKccpJjijIvCegh/view?usp=drive_link"
                  target="_blank"
                  rel="noreferrer"
                >
                  instructivo para obtener tu PDF.
                </a>
              </li>
              <li>Recibe una respuesta inmediata al finalizar el trámite.</li>
            </ol>
          </div>
        </Card>
      </Wrapper>
    </WhiteContainer>
  </div>
);

export { ProcedureInfoComponent };
